import React, {Component} from 'react';
import "./who_we_are.sass"
import 'antd/dist/antd.css';
import i18next from "../../utils/i18n";
import FirebaseContext from "../../components/Firebase/context";
import {Icon} from 'antd';


class WhoWeAre extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            // Important! Always set the container height explicitly
            <div className="contact info_col">
                <div className="info_row_title">
                    <div className="info_col_img">
                        <div className="logo_small_who"></div>
                        <div className="logo_cme"></div>
                    </div>
                    <div className="info_col_title">
                        <label className="who_are_info_title">{i18next.t("CONTACT_US.title_header")}</label>
                        <label className="who_are_info">{i18next.t("CONTACT_US.title_header_2")}</label>
                        <label className="who_are_info">{i18next.t("CONTACT_US.title_header_3")}</label>
                        <label className="who_are_info">{i18next.t("CONTACT_US.title_header_4")}</label>
                    </div>
                </div>
                <h1 className="title">{i18next.t("CONTACT_US.title")}</h1>
                <div className="info_row">
                    <Icon className="icon" type="car" theme="filled"/>
                    <label className="lab">{i18next.t("CONTACT_US.address")}</label>
                </div>
                <div className="info_row">
                    <Icon className="icon" type="phone" rotate={90}/>
                    <label
                        className="lab">{i18next.t("CONTACT_US.number_home")} - {i18next.t("CONTACT_US.number_phone")}</label>
                </div>
                <div className="info_row">
                    <Icon className="icon" type="mail" theme="filled"/>
                    <label className="lab">{i18next.t("CONTACT_US.email")}</label>
                </div>

                <div className="container_img">
                    <a href="https://goo.gl/maps/7dcF1sh2wRtemjFa6">
                        <div className="map_img"></div>
                    </a>
                </div>

            </div>
        );
    }

}


WhoWeAre.contextType = FirebaseContext;

export default WhoWeAre;